import { FaqData } from "../../../hooks/useApiCalls";
import FaqCard from "./components/FaqCard";


function Faq() {

    const faq = FaqData();
    let faqD = faq ? faq : [];

 
    return ( 
       <>

        <section id="faq" className="py-5">
                <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                    <h2 className="text-center mb-5">FAQ</h2>
                    <div className="accordion" id="faqAccordion">
                        {Array.isArray(faqD) && faqD.map((data)=>{
                             return <FaqCard id={data.id} title={data.title} rank={data.rank} text={data.text} />
                        })}
                    </div>
                    </div>
                </div>
                </div>
            </section>
         
    </> 
 ); 

}

export default Faq;